import { datadogLogs } from "@datadog/browser-logs";

import {
  CARSA_NET_BASE_URL,
  ESCALATE_VALUATION_ENDPOINT,
  SUBMIT_VALUATION_ENDPOINT,
} from "../resources/APP_CONSTANTS";
import {
  CarsanetValuationsResponse,
  EscalateValuationPayload,
  SubmitValuationPayload,
} from "../types/apis";
import { ISubmitValuationClient } from ".";

export class CarsanetClient implements ISubmitValuationClient {
  async submitValuation(
    payload: SubmitValuationPayload,
    bearerToken: string,
  ): Promise<string> {
    datadogLogs.logger.info("Submitting Valuation to Carsanet", {
      payload: payload,
    });
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
      body: JSON.stringify(payload),
    };

    let response;

    try {
      response = await fetch(
        CARSA_NET_BASE_URL + SUBMIT_VALUATION_ENDPOINT,
        requestOptions,
      );
    } catch (err) {
      throw new Error("Submit valuation failed due to fetch" + err);
    }
    const responseJson: CarsanetValuationsResponse = await response.json();

    if (response.ok) {
      return responseJson.urlToRedirect;
    }

    throw new Error("Submit Valuation failed.");
  }
  async escalateValuation(
    payload: EscalateValuationPayload,
    bearerToken: string,
  ): Promise<string> {
    datadogLogs.logger.info("Escalating Valuation to Carsanet", {
      payload: payload,
    });
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
      body: JSON.stringify(payload),
    };

    let response;

    try {
      response = await fetch(
        CARSA_NET_BASE_URL + ESCALATE_VALUATION_ENDPOINT,
        requestOptions,
      );
    } catch (err) {
      throw new Error("Escalate valuation failed due to fetch" + err);
    }
    const responseJson: CarsanetValuationsResponse = await response.json();

    if (response.ok) {
      return responseJson.urlToRedirect;
    }

    throw new Error("Escalate valuation failed.");
  }
}
